"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeatured = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new featured object.
 *
 * ## Usage
 *
 * ```ts
 * const featured: Omit<FeaturedVideo, 'date'> = {
 *  type: FeaturedType.VIDEO,
 *  memberId: "6547839284576",
 *  description: "Watch me die 7439578493e times in VVVVVV failed YOLO attempt",
 *  link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
 *  gameId: 70300,
 *  gameTitle: null,
 *  gameLink: null,
 * };
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createFeatured({ featured });
 * ```
 *
 * @param params.featured - Data of the new featured object.
 */
const createFeatured = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { featured } = params;
    const url = `${BASE_URL}/featured`;
    const featuredResponse = yield axios_1.default.post(url, featured, { validateStatus: () => true });
    const { status, data } = featuredResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createFeatured = createFeatured;
